import React, { useState, useEffect } from 'react'
import PageHeader from '@/components/PageHeader'
import BluePlaceholder from '@/components/BluePlaceholder'
import { GALLERY_CATS } from '@/data/gallery'
import api, { imgSrc } from '@/api/index'

export default function GalleryPage() {
  const [cat, setCat] = useState('All');
  const [light, setLight] = useState(null);
  const [allItems, setAllItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/gallery')
      .then(({ data }) => setAllItems(data.data))
      .finally(() => setLoading(false));
  }, []);

  const filtered = cat === 'All' ? allItems : allItems.filter(i => i.cat === cat);

  return (
    <div className="page">
      <PageHeader eyebrow="Highlights"
        title={<>From <span style={{ color: 'var(--accent)' }}>our sites</span>.</>}
        sub="A handpicked selection from active sites, completed buildings, our crew and machinery."
        badge="Updated regularly · curated by SMT"
        variant="highlights" />

      <div style={{ position: 'sticky', top: 64, zIndex: 50, background: 'rgba(245,245,242,0.9)', backdropFilter: 'blur(14px)', borderBottom: '1px solid var(--line-soft)' }}>
        <div className="container gallery-filter" style={{ padding: '20px 48px', display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
          <span className="mono" style={{ color: 'var(--fg-3)' }}>FILTER /</span>
          {GALLERY_CATS.map(c => (
            <button key={c} onClick={() => setCat(c)} style={{
              background: c === cat ? 'var(--accent)' : 'transparent',
              color: c === cat ? '#0a0a0c' : 'var(--fg-1)',
              border: '1px solid', borderColor: c === cat ? 'var(--accent)' : 'var(--line)',
              padding: '7px 14px', cursor: 'pointer',
              fontFamily: 'var(--mono)', fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase',
            }}>{c}</button>
          ))}
        </div>
      </div>

      <section style={{ padding: '48px 0' }}>
        <div className="container">
          {loading ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gridAutoRows: '200px', gap: 12 }} className="masonry">
              {[0,1,2,3,4,5,6,7].map(i => (
                <div key={i} style={{ background: 'var(--bg-2)', borderRadius: 8, animation: 'pulse 1.5s ease-in-out infinite' }} />
              ))}
              <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.45} }`}</style>
            </div>
          ) : allItems.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '80px 0', color: 'var(--fg-2)' }}>
              <div className="mono" style={{ fontSize: 13, color: 'var(--fg-3)' }}>No highlights yet</div>
              <p style={{ marginTop: 8, fontSize: 14 }}>Upload images from the admin panel to display them here.</p>
            </div>
          ) : (
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
            gridAutoRows: '200px', gap: 12,
          }} className="masonry">
            {filtered.map((it) => {
              const sty = it.span === 'tall' ? { gridRow: 'span 2' }
                : it.span === 'wide' ? { gridColumn: 'span 2' }
                : {};
              return (
                <button key={it._id || it.id} onClick={() => setLight(it)} className="lift" style={{
                  ...sty, all: 'unset', cursor: 'pointer',
                }}>
                  <div style={{ width: '100%', height: '100%' }}>
                    <BluePlaceholder label={it.label} sub={it.sub} variant={it.variant} src={imgSrc(it.img)} height="100%" />
                  </div>
                </button>
              );
            })}
          </div>
          )}
        </div>
        <style>{`@media (max-width: 900px) { .masonry { grid-template-columns: 1fr 1fr !important; } } @media (max-width: 540px) { .masonry { grid-template-columns: 1fr !important; } .masonry > * { grid-column: span 1 !important; grid-row: span 1 !important; } }`}</style>
      </section>

      {light && (
        <div onClick={() => setLight(null)} style={{
          position: 'fixed', inset: 0, zIndex: 300,
          background: 'rgba(245,245,242,0.9)', backdropFilter: 'blur(8px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 60,
        }}>
          <button onClick={() => setLight(null)} style={{
            position: 'absolute', top: 24, right: 24,
            background: 'var(--bg-0)', border: '1px solid var(--line)', color: 'var(--fg-0)',
            padding: '8px 16px', cursor: 'pointer', fontFamily: 'var(--mono)', fontSize: 11,
          }}>CLOSE ✕</button>
          <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 1200 }}>
            <BluePlaceholder label={light.label} sub={light.sub} variant={light.variant} src={imgSrc(light.img) || light.img} height={640} />
            <div className="mono" style={{ marginTop: 16, color: 'var(--fg-2)', display: 'flex', justifyContent: 'space-between' }}>
              <span>{light.label} · {light.cat}</span><span>{light.sub}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
